import BpmnParserProvider from './BpmnParserProvider';

export default {
  __init__: ['bpmnParser'],
  bpmnParser: ['type', BpmnParserProvider]
};
